// extracted by mini-css-extract-plugin
export default {"changeLink":"PL-z","disabled":"QL-z","inline":"RL-z"};